import React, { createContext, useState } from 'react';

const ModelContext = createContext();

function ModelDataProvider ({ children }){

    const [modelData, setModelData] = useState(null);

    const saveModelData = (newData) => {
      setModelData((prevData) => ({ ...prevData, ...newData }));
    };

    return (
      <ModelContext.Provider value={{ modelData, saveModelData }}>
        {children}
      </ModelContext.Provider>
    );
};

export { ModelContext, ModelDataProvider };